<template>
  <v-container :class="'area area-' + name">
    <slot></slot>
  </v-container>
</template>

<script>
export default {
  name: "LatestArea",
  props: {
    name: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.area {
  overflow-y: auto;
}

/* Layout areas */
.area-A {
  grid-area: A;
}
.area-B0 {
  grid-area: B0;
}
.area-B1 {
  grid-area: B1;
}
.area-C {
  grid-area: C;
}
</style>
